import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import Topbar from './components/Topbar';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import { Services, Incidents, Reports } from './pages/OtherPages';
import Vault from './pages/Vault';
import PasswordTools from './pages/PasswordTools';
import TravelAdvisory from './pages/TravelAdvisory';
import Privacy from './pages/Privacy';
import './index.css';

const NAV = [
  { path: '/dashboard', label: 'Home',     icon: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' },
  { path: '/chat',      label: 'Concierge',icon: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' },
  { path: '/services',  label: 'Services', icon: 'M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2zm-1 13l-3-3 1.41-1.41L11 12.17l4.59-4.58L17 9l-6 6z' },
  { path: '/incidents', label: 'Cases',    icon: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 14l-3-3 1.41-1.41L11 12.17l4.59-4.58L17 9l-6 6z' },
  { path: '/passwords', label: 'Passwords',icon: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' },
  { path: '/reports',   label: 'Reports',  icon: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z' },
  { path: '/vault',     label: 'Vault',    icon: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' },
  { path: '/travel',    label: 'Travel',   icon: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' },
  { path: '/privacy',   label: 'My Data',  icon: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4.18L18 8v3c0 3.61-2.46 7-6 8.26C8.46 18 6 14.61 6 11V8l6-2.82zM11 7L7 11l1.41 1.41L11 9.83l4.59 4.58L17 13z' },
];

function BottomNav() {
  return (
    <nav className="bottom-nav" style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'var(--bg-surface)', borderTop: '0.5px solid var(--border)',
      display: 'flex', zIndex: 50, padding: '8px 0 8px',
    }}>
      {NAV.map(n => (
        <NavLink key={n.path} to={n.path} style={({ isActive }) => ({
          flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
          gap: 3, textDecoration: 'none', padding: '4px 0',
          color: isActive ? 'var(--gold)' : 'var(--text-secondary)',
          fontSize: 10, letterSpacing: '0.03em',
        })}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
            <path d={n.icon} />
          </svg>
          {n.label}
        </NavLink>
      ))}
    </nav>
  );
}

function DesktopSidebar() {
  return (
    <div style={{
      width: 210, background: 'var(--bg-surface)', borderRight: '0.5px solid var(--border)',
      display: 'flex', flexDirection: 'column', padding: '16px 0', flexShrink: 0,
    }}>
      {[
        { group: 'HOME', items: NAV.slice(0, 2) },
        { group: 'PROTECTION', items: NAV.slice(2, 5) },
        { group: 'INTELLIGENCE', items: NAV.slice(5, 7) },
        { group: 'TRAVEL', items: NAV.slice(7, 8) },
        { group: 'ACCOUNT', items: NAV.slice(8) },
      ].map(({ group, items }) => (
        <div key={group} style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 10, color: 'var(--text-muted)', letterSpacing: '0.12em', padding: '0 16px', marginBottom: 6 }}>{group}</div>
          {items.map(n => (
            <NavLink key={n.path} to={n.path} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '9px 16px', fontSize: 13, textDecoration: 'none',
              borderLeft: `2px solid ${isActive ? 'var(--gold)' : 'transparent'}`,
              color: isActive ? 'var(--gold)' : 'var(--text-secondary)',
              background: isActive ? 'var(--bg-raised)' : 'transparent',
            })}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d={n.icon} />
              </svg>
              {n.label}
            </NavLink>
          ))}
        </div>
      ))}
    </div>
  );
}

function Protected({ children }) {
  const { client } = useAuth();
  return client ? children : <Navigate to="/login" replace />;
}

function PortalLayout() {
  const [isMobile] = useState(() => window.innerWidth < 768);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <Topbar />
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {!isMobile && <DesktopSidebar />}
        <main style={{
          flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden',
          paddingBottom: isMobile ? 'var(--bottom-nav-h)' : 0,
        }}>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/chat"      element={<Chat />} />
            <Route path="/services"  element={<Services />} />
            <Route path="/incidents" element={<Incidents />} />
            <Route path="/passwords" element={<PasswordTools />} />
            <Route path="/reports"   element={<Reports />} />
            <Route path="/vault"     element={<Vault />} />
            <Route path="/travel"    element={<TravelAdvisory />} />
            <Route path="/privacy"   element={<Privacy />} />
            <Route path="*"          element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </main>
      </div>
      {isMobile && <BottomNav />}
    </div>
  );
}

function AppRoutes() {
  const { client } = useAuth();
  const [showSignup, setShowSignup] = React.useState(false);
  if (showSignup) return <Signup onLogin={() => setShowSignup(false)} />;
  return (
    <Routes>
      <Route path="/login" element={client ? <Navigate to="/dashboard" replace /> : <Login onSignup={() => setShowSignup(true)} />} />
      <Route path="/*"     element={<Protected><PortalLayout /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
